import { apiClient } from "../client";
import type {
  AllowedExtensionsResponse,
  AllowedPageSizesResponse,
  RuleCategoriesResponse,
} from "./types";
import {
  allowedExtensionsResponseSchema,
  allowedPageSizesResponseSchema,
  ruleCategoriesResponseSchema,
} from "./schemas";

export async function getAllowedExtensions(): Promise<AllowedExtensionsResponse> {
  const response = await apiClient
    .get("config/allowed-extensions", {})
    .json<AllowedExtensionsResponse>();

  return allowedExtensionsResponseSchema.parse(response);
}

export async function getAllowedPageSizes(): Promise<AllowedPageSizesResponse> {
  const response = await apiClient
    .get("config/allowed-page-sizes", {})
    .json<AllowedPageSizesResponse>();

  return allowedPageSizesResponseSchema.parse(response);
}

export async function getRuleCategories(): Promise<RuleCategoriesResponse> {
  const response = await apiClient
    .get("config/rule-categories", {})
    .json<RuleCategoriesResponse>();

  return ruleCategoriesResponseSchema.parse(response);
}
